import styled from 'styled-components';

export const Container = styled.div`
  .dados-curriculo th {
    padding-top: 5px;
  }

  .curriculos h4 {
    margin-bottom: 20px;
  }

  .conteudo {
    background: #fff;
    padding: 20px;
  }
`;
